import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { RootState } from "store";
import { formatNumber } from "utils/helpers";

const SocialPerformance = () => {
    const { campaignId } = useParams();

    const campaignInsightsData = useSelector((state: RootState) => state.campaignInsights.campaigns[campaignId!]);

    const insights = campaignInsightsData?.insights;
    const campaign = campaignInsightsData?.campaign;

    const connectionRequired = useSelector((state: RootState) => state.campaigns.items[campaignId!]?.data?.campaign?.connection_required);

    return (
        <div className="card campaign-insights-card mb-0 mt-4">
            <div className="card-header bg-success-light px-4">
                <span>Social Performance</span>
            </div>
            <div className="card-body d-flex flex-column gap-3 p-4">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="title">
                        <span className="oval blue"></span>
                        Total Interactions
                    </div>
                    <div className="value">
                        <span>{formatNumber(insights?.engagement?.total_interactions?.value ?? 0)}</span>
                    </div>
                </div>
                {/* <div className="d-flex justify-content-between align-items-center">
                    <div className="title">
                        <span className="oval red"></span>
                        Total Accounts Reached
                    </div>
                    <div className="value">
                        <span>{formatNumber(insights?.engagement?.reach?.value ?? 0)}</span>
                    </div>
                </div> */}
                <div className="d-flex justify-content-between align-items-center">
                    <div className="title">
                        <span className="oval skyblue"></span>
                        Total Views
                    </div>
                    <div className="value">
                        <span>{formatNumber(insights?.engagement?.views?.value ?? 0)}</span>
                    </div>
                </div>
                {
                    campaign?.mode !== 'offline' && campaign?.reporting_type !== 'repost' && connectionRequired &&
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="title">
                            <span className="oval red"></span>
                            Total Watch Time
                        </div>
                        <div className="value">
                            <span>{campaign?.total_watch_time ?? '-'}</span>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default SocialPerformance